import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=771f6ed9&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f6ed9",
  null
  
)

export default component.exports